import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CoreSidebarService} from '../../../@core/components/core-sidebar/core-sidebar.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {OrderService} from '../../shared/services/order.service';
import {TransactionService} from '../../shared/services/transaction.service';
import {StorageService} from '../../shared/services/storage.service';
import {Router} from '@angular/router';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-orders',
    templateUrl: './orders.component.html',
    styleUrls: ['./orders.component.scss']
})
export class OrdersComponent implements OnInit {
    data: any;
    id: any;
    showSearch = false;
    orders = [];
    updateDeliveryStatusForm: FormGroup;
    searchForm: FormGroup;
    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };
    submitted: any = false;
    submitting: any = false;
    selectedTransactionData: any;
    user: any;
    modalType: any;

    constructor(private _coreSidebarService: CoreSidebarService,
                private transactionService: TransactionService,
                private orderService: OrderService,
                public modalService: NgbModal,
                private router: Router,
                private fb: FormBuilder) {
        this.user = StorageService.getItem('self');
        if (!this.user || !this.user['user_type'] || (this.user['user_type'] !== 'ADMIN' && this.user['user_type'] !== 'SUPER_ADMIN' && this.user['user_type'] !== 'CONSULTANT')) {
            this.router.navigateByUrl('dashboard');
        }
    }

    ngOnInit(): void {
        this.refresh();
    }

    refresh() {
        this.searchForm = this.fb.group({
            'name': [''],
            'contact': [''],
            'invoice_no': ['']
        });
        this.updateDeliveryStatusForm = this.fb.group({
            'delivery_status': ['', Validators.required]
        });
        this.get();
    }

    add(): void {
        this.data = undefined;
    }

    search() {
        const params = {
            'name': (this.searchForm.value && this.searchForm.value.name) ? this.searchForm.value.name : '',
            'contact': (this.searchForm.value && this.searchForm.value.contact) ? this.searchForm.value.contact : '',
            'invoice_no': (this.searchForm.value && this.searchForm.value.invoice_no) ? this.searchForm.value.invoice_no : ''
        };
        this.get(params);
    }

    get(params: any = {}) {
        params.page = this.pagination.page;
        params.per_page = this.pagination.perpage;
        this.submitting = true;
        this.orders = [];
        this.transactionService.get(params).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.orders = data['data'];
                if (this.orders && this.orders && this.orders.length > 0) {
                    this.orders.forEach(order => {
                        if (order && order['orders'] && order['orders'].length > 0) {
                            order['orders'].forEach(od => {
                                od['total_price'] = Math.round((parseFloat(od['discounted_price']) * parseFloat(od['quantity'])) + ((parseFloat(od['discounted_price']) * parseFloat(od['quantity'])) * parseFloat(od['igst']) / 100));
                            })
                        }
                    });
                }
                this.pagination = {
                    page: data.current_page,
                    total: data.total,
                    perpage: data.per_page,
                    pages: data.last_page,
                };
            } else {
                this.orders = [];
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    onPageChange(page) {
        this.pagination.page = page;
        const params = {
            'name': (this.searchForm.value && this.searchForm.value.name) ? this.searchForm.value.name : '',
            'contact': (this.searchForm.value && this.searchForm.value.contact) ? this.searchForm.value.contact : '',
            'invoice_no': (this.searchForm.value && this.searchForm.value.invoice_no) ? this.searchForm.value.invoice_no : ''
        };
        this.get(params);
    }

    changeDeliveryStatus(content, data) {
        this.modalType = 'CHANGE_DELIVERY_STATUS';
        this.modalService.open(content, {'size': 'lg'});
        this.selectedTransactionData = data;
    }

    updateStatus() {
        this.orderService.orderDeliveryStatus(this.selectedTransactionData['orders']['0']['order_id'], this.updateDeliveryStatusForm.value).subscribe(data => {
            this.get();
            this.modalService.dismissAll('');
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    viewOrders(content, data) {
        this.modalType = 'VIEW_ORDERS';
        this.modalService.open(content, {'size': 'xl'});
        this.selectedTransactionData = data;
    }

    deleteTransaction(data) {
        this.transactionService.delete(data.id).subscribe(data => {
            this.get();
        });
    }

    openExternalUrl(url) {
        window.open(environment.appUrl + url, '_blank');
    }
}
